

// it takes an arrya of object and a key of object as argument. it removes duplicate value of that key
export const removeDuplicateFunc = (arr, key) => {
    const unique = arr.filter((obj, index) => {
        return index === arr.findIndex(o => obj[key] === o[key]);
    });
}


// Helper function to format date
export const formatDate = (timestamp) => {
    if (!timestamp) return "";
    const date = new Date(timestamp);
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
};

// Format as "July 9, 2025, 6:00 AM"
export const formatDateTime = dateString => {
    const date = new Date(dateString);
    const options = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        timeZone: 'UTC' // since your input is in UTC
    };
    return date.toLocaleString('en-US', options);
};